import * as React from 'react';
import { useLoginCheckQuery } from '@graphql';
import { NavBar } from '@components/student/NavBar';
export const NavBarContainer = (props) => {
    var _a;
    const { data, error } = useLoginCheckQuery();
    const isLoggedIn = Boolean((_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.id);
    return React.createElement(NavBar, Object.assign({}, props, { isLoggedIn: isLoggedIn }));
};
